import { useState } from "react";
import { useModalStore } from "../../../stores/modalStore.js";

export function EnhancedSettingsModal() {
  const { isOpen, type, onClose } = useModalStore();
  const [tab, setTab] = useState("general");
  const [blockedUsers, setBlockedUsers] = useState([
    { id: 1, username: "Troll123" },
    { id: 2, username: "Spammer" },
  ]);
  const [channelNotifications, setChannelNotifications] = useState({
    general: { muted: false, mentions: true },
    announcements: { muted: true, mentions: true },
    support: { muted: false, mentions: false },
  });

  const isModalOpen = isOpen && type === "enhancedSettings";

  if (!isModalOpen) return null;

  const handleUnblockUser = (id) => {
    setBlockedUsers(blockedUsers.filter((u) => u.id !== id));
  };

  const handleToggleMuted = (channel) => {
    setChannelNotifications({
      ...channelNotifications,
      [channel]: {
        ...channelNotifications[channel],
        muted: !channelNotifications[channel].muted,
      },
    });
  };

  return (
    <div
      className="modal-overlay"
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#1a1a1a",
          border: "1px solid #2a2a2a",
          borderRadius: "8px",
          width: "90%",
          maxWidth: "600px",
          maxHeight: "80vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
        <div style={{ padding: "20px", borderBottom: "1px solid #2a2a2a", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h2 style={{ margin: 0, color: "#fff" }}>Settings</h2>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              color: "#666",
              fontSize: "1.5rem",
              cursor: "pointer",
            }}
          >
            ✕
          </button>
        </div>

        {/* Tabs */}
        <div style={{ display: "flex", borderBottom: "1px solid #2a2a2a", background: "#0f0f0f" }}>
          {["general", "notifications", "blocked", "privacy"].map((tabName) => (
            <button
              key={tabName}
              onClick={() => setTab(tabName)}
              style={{
                flex: 1,
                padding: "12px",
                background: tab === tabName ? "#0066ff" : "transparent",
                border: "none",
                color: tab === tabName ? "#fff" : "#666",
                cursor: "pointer",
                fontFamily: "'Roboto Mono', monospace",
                textTransform: "capitalize",
              }}
            >
              {tabName}
            </button>
          ))}
        </div>

        {/* Content */}
        <div style={{ flex: 1, overflowY: "auto", padding: "20px" }}>
          {tab === "general" && (
            <div>
              <h3 style={{ color: "#fff", marginTop: 0 }}>General Settings</h3>
              <label style={{ display: "block", marginBottom: "16px", color: "#e0e0e0" }}>
                <input type="checkbox" defaultChecked /> Compact Mode
              </label>
              <label style={{ display: "block", marginBottom: "16px", color: "#e0e0e0" }}>
                <input type="checkbox" defaultChecked /> Show Timestamps
              </label>
              <label style={{ display: "block", color: "#e0e0e0" }}>
                <input type="checkbox" /> Developer Mode
              </label>
            </div>
          )}

          {tab === "notifications" && (
            <div>
              <h3 style={{ color: "#fff", marginTop: 0 }}>Channel Notifications</h3>
              {Object.entries(channelNotifications).map(([channel, settings]) => (
                <div key={channel} style={{ marginBottom: "16px", padding: "12px", background: "#0f0f0f", borderRadius: "4px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span style={{ color: "#e0e0e0", textTransform: "capitalize" }}>#{channel}</span>
                    <button
                      onClick={() => handleToggleMuted(channel)}
                      style={{
                        padding: "6px 12px",
                        background: settings.muted ? "#ff0000" : "#00ff00",
                        border: "none",
                        borderRadius: "4px",
                        color: "#000",
                        cursor: "pointer",
                        fontSize: "0.75rem",
                        fontWeight: "bold",
                      }}
                    >
                      {settings.muted ? "Muted" : "Unmuted"}
                    </button>
                  </div>
                  <label style={{ display: "block", marginTop: "8px", color: "#999", fontSize: "0.85rem" }}>
                    <input type="checkbox" checked={settings.mentions} readOnly /> Notify on mentions
                  </label>
                </div>
              ))}
            </div>
          )}

          {tab === "blocked" && (
            <div>
              <h3 style={{ color: "#fff", marginTop: 0 }}>Blocked Users</h3>
              {blockedUsers.length === 0 ? (
                <p style={{ color: "#666" }}>No blocked users</p>
              ) : (
                blockedUsers.map((user) => (
                  <div key={user.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px", background: "#0f0f0f", marginBottom: "8px", borderRadius: "4px" }}>
                    <span style={{ color: "#e0e0e0" }}>{user.username}</span>
                    <button
                      onClick={() => handleUnblockUser(user.id)}
                      style={{
                        padding: "6px 12px",
                        background: "#0066ff",
                        border: "none",
                        borderRadius: "4px",
                        color: "#fff",
                        cursor: "pointer",
                        fontSize: "0.75rem",
                      }}
                    >
                      Unblock
                    </button>
                  </div>
                ))
              )}
            </div>
          )}

          {tab === "privacy" && (
            <div>
              <h3 style={{ color: "#fff", marginTop: 0 }}>Privacy Settings</h3>
              <label style={{ display: "block", marginBottom: "16px", color: "#e0e0e0" }}>
                <input type="checkbox" defaultChecked /> Allow friend requests
              </label>
              <label style={{ display: "block", marginBottom: "16px", color: "#e0e0e0" }}>
                <input type="checkbox" defaultChecked /> Show online status
              </label>
              <label style={{ display: "block", color: "#e0e0e0" }}>
                <input type="checkbox" /> Show activity status
              </label>
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{ padding: "16px", borderTop: "1px solid #2a2a2a", display: "flex", justifyContent: "flex-end" }}>
          <button
            onClick={onClose}
            style={{
              padding: "10px 20px",
              background: "#0066ff",
              border: "none",
              borderRadius: "4px",
              color: "#fff",
              cursor: "pointer",
              fontFamily: "'Roboto Mono', monospace",
            }}
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
}
